import { PageWithAppBar } from '$common/page-with-app-bar'
import { AppBarBackTitle } from '$common/app-bar/app-bar-back-title'
import { SettingsSection } from '$common/settings-section'
import { SettingsNotifs } from './settings-notifs'
import { SettingsPrivacy } from './settings-privacy'
import { SettingsStorage } from './settings-storage'
import { SettingsSecurity } from './settings-security'
import { t } from '$i18n'
import { closeSettings } from '$logic/router'
import {
  showDeleteAccountModal,
  showLogoutModal,
} from '$comp/modals/confirmation-dialog'
import { SettingsContacts } from './settings-contacts'
import { ArrowIOSIcon } from '$common/icons'
import { SettingsItemWithIcon } from '$common/settings-item'
import { ListItemCriticalTextButton } from '$common/buttons'
// import { SettingLanguage } from './setings-language'
import { LogoutIcon } from '@weblite/icons'

export function Settings() {
  return (
    <PageWithAppBar
      rootSx={{ textAlign: 'right' }}
      appBar={
        <AppBarBackTitle title={t('settings.title')} onBack={closeSettings} />
      }
      bodySx={{ paddingBottom: '8px' }}
    >
      <SettingsNotifs />
      <SettingsPrivacy />
      {/* <SettingsContacts /> */}
      <SettingsStorage />
      <SettingsSecurity />
      {/* <SettingLanguage /> */}

      <SettingsSection>
        <ListItemCriticalTextButton
          text={t('settings.logout')}
          onClick={showLogoutModal}
          // Icon={LogoutIcon}
        />
      </SettingsSection>

      {/* {import.meta.env.VITE_ENABLE_DELETE_ACCOUNT === 'true' && (
        <SettingsSection>
          <SettingsItemWithIcon
            text={t('settings.deleteAccount.title')}
            Icon={ArrowIOSIcon}
            onClick={showDeleteAccountModal}
            color="error500"
          />
        </SettingsSection>
      )} */}
    </PageWithAppBar>
  )
}
